import React from 'react';
import ReactDOM from 'react-dom';

import { IconType } from 'react-icons/lib/esm';
import { IoIosCube } from 'react-icons/io';
import { MdOutlineAttachMoney } from 'react-icons/md';

import { qdtComponents } from './config/globalApp';
import App from './App';
import { sheetData } from './context/SheetContext';

import './assets/styles.css';

function loadPage(sheets: sheetData[]): void {
  const sheetsView: sheetData[] = sheets;

  ReactDOM.render(
    <React.StrictMode>
      <App sheets={sheetsView} appProps={{}} />
    </React.StrictMode>,
    document.getElementById('root'),
  );
}

(async function getApp() {
  const qDoc = await qdtComponents.qDocPromise;

  const sheets: sheetData[] = [];
  const sheetsList: string[] = [
    '90c4f823-a335-4d9a-b7d5-fe9adaeb114f',
    '8c72df54-3638-40d4-a680-c38058f11391',
  ];

  function linkSerialized(
    layout: EngineAPI.IGenericObjectLayout,
    sheet: string,
  ): void {
    let title = '';
    let idx = 0;
    let menuIcon: IconType = IoIosCube;
    switch (sheet) {
      case '90c4f823-a335-4d9a-b7d5-fe9adaeb114f':
        title = 'Payments';
        menuIcon = MdOutlineAttachMoney;
        idx = 0;
        break;
      case '8c72df54-3638-40d4-a680-c38058f11391':
        title = 'Gainers and Losers';
        menuIcon = MdOutlineAttachMoney;
        idx = 1;
        break;
      default:
        break;
    }

    sheets.push({
      id: String(sheet),
      title: title || layout.qMeta.title,
      cells: layout.cells,
      columns: layout.columns,
      rows: layout.rows,
      menuIcon,
      menuIndex: idx,
      height: layout.height,
    });
  }

  if (qDoc) {
    Promise.all(
      sheetsList.map(async sheet => {
        const obj = await qDoc.getObject(sheet);
        const layout = await obj.getLayout();
        linkSerialized(layout, sheet);
      }),
    ).then(() => {
      sheets.sort((a, b) =>
        a.menuIndex > b.menuIndex ? 1 : b.menuIndex > a.menuIndex ? -1 : 0,
      );
      loadPage(sheets);
    });
  }
})();
